if (!customElements.get('sotto-header')) {
  customElements.define(
    'sotto-header',
    class SottoHeader extends HTMLElement {
      constructor() {
        super();
        this.header = this.querySelector('.sotto-header');
        this.toggle = this.querySelector('[data-sotto-menu-toggle]');
        this.mobileMenu = this.querySelector('[data-sotto-mobile-menu]');
      }

      connectedCallback() {
        this.onScroll = () => {
          this.header.classList.toggle('is-scrolled', window.scrollY > 50);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        if (this.toggle && this.mobileMenu) {
          this.toggle.addEventListener('click', () => this.toggleMenu());
          this.mobileMenu.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', () => this.closeMenu());
          });
          document.addEventListener('keyup', (event) => {
            if (event.code === 'Escape') this.closeMenu();
          });
          document.addEventListener('click', (event) => {
            if (!this.contains(event.target)) this.closeMenu();
          });
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      toggleMenu() {
        const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          this.closeMenu();
        } else {
          this.mobileMenu.hidden = false;
          this.toggle.setAttribute('aria-expanded', 'true');
          this.header.classList.add('menu-open');
        }
      }

      closeMenu() {
        if (!this.mobileMenu || this.mobileMenu.hidden) return;
        this.mobileMenu.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.header.classList.remove('menu-open');
      }
    }
  );
}
